
/**
 * @Name: 全局过滤器定义
 */
let showDateYMD = (value) => {
    if (value) {
        return value.split('T')[0]
    } else {
        return ''
    }
}
export {
    showDateYMD
}
